<template>
    <Modal v-if="modalOpen" :is-card="true" :has-close-button="true" @close="closeModal">
        <template v-slot:header>
            <div class="modal__header-container">
                <h2 class="modal___heading modal__heading--align-center">{{ modalData.display_name || '' }}</h2>
            </div>
        </template>

        <template v-slot:body>
            <template v-if="modalData.description">
                <h3>Description:</h3>

                <p class="modal__body-description">{{ modalData.description || '' }}</p>
            </template>

            <template v-if="modalData.benefits">
                <h3>Benefits:</h3>

                <p v-html="modalData.benefits || ''"></p>
            </template>
        </template>
    </Modal>
</template>

<script>
import Modal from '../../../core/components/ConfiguratorModal.vue';

export default {
    components: {
        Modal,
    },
    props: {
        modalOpen: {
            type: Boolean,
            default: false,
        },
        modalData: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
    },
}
</script>